module.exports = __webpack_public_path__ + "static/media/citycolis-holding-logo.1409328d.svg";